import { render, staticRenderFns } from "./arkmanxmlaktarim.vue?vue&type=template&id=4484c2aa&"
import script from "./arkmanxmlaktarim.vue?vue&type=script&lang=js&"
export * from "./arkmanxmlaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports